import * as React from "react"
import * as styles from './nav.module.scss';
import { Link } from "gatsby";
import { useSiteMetadata } from "../../hooks/use-site-metadata"
import { MenuButton } from "./menu-button";
import { motion, useCycle } from "framer-motion"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons'

const links = [
  {
    text: "About Sergio",
    url: "/about",
  },
  {
    text: "Why I'm Running",
    url: "/why-running",
  },
  {
    text: "Press",
    url: "/press",
  },
  {
    text: "Endorsements",
    url: "/endorsements",
  },
  {
    text: "Contact",
    url: "/contact",
  },
]


const Nav = (props) => {

  const { donationURL } = useSiteMetadata();

  const [isOpen, toggleOpen] = useCycle(false, true);

  const navList = {
    open: {
      height: 'auto',
      // padding: '1rem 0',
      transition: { 
        delay: 0,
        duration: 0.2,
        staggerChildren: 0.3,
        staggerDirection: 1
      }
    },
    closed: {
      height:0,
      // padding: '0',
      transition: { 
        delay: 0.5,
        duration: .2,
        staggerChildren: 0.15,
        staggerDirection: -1
      }
    },
  };

  const listItemVarriants = {
    initial: {
      y: -20
    },
    closed: {
      opacity: 0,
      y: -20,
      pointerEvents: 'none',
      cursor: 'default',
      transition: { 
        // delay: 0.45,
        duration: .2,
      }
    },
    open: { 
      opacity: 1,
      y: 0,
      pointerEvents: 'unset',
      cursor: 'unset',
      transition: { 
        // delay: 0.45,
        duration: .65,
      }
    }
  };

  return (
    <nav className={styles.siteNav}>

      <button 
        className={styles.menuButton}
        onClick={() => toggleOpen()}>
        <span className="sr-only">Open Menu</span>
        <MenuButton
          isOpen={isOpen}
          strokeWidth="2"
          color="#ffffff"
          lineProps={{ strokeLinecap: "round" }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className={styles.menuButtonSVG}
          width={18}
          height={13.5}
        />
      </button>


      <motion.ul
        className={`global-nav-list ${styles.navList} ${styles.navListMobile}`}
        initial={false}
        animate={isOpen ? "open" : "closed"}
        variants={navList}
        >
        {links.map( (link, key) => (
          <motion.li
          key={key}
          variants={listItemVarriants}>
            <Link to={link.url} activeClassName={styles.activeLink}>{link.text}</Link>
          </motion.li>
        ))}
        <motion.li variants={listItemVarriants}>
          <a href={donationURL} className={`button primary ${styles.donateButton}`}><span>Donate&nbsp;<FontAwesomeIcon icon={faArrowRightLong} size="xs" /></span></a>
        </motion.li>
      </motion.ul>

      <ul className={`${styles.navList} ${styles.navListDesktop}`}>
      {links.map( (link, key) => (
          <li key={key}>
            <Link to={link.url} activeClassName={styles.activeLink}>{link.text}</Link>
          </li>
        ))}
        <li>
          <a href={donationURL} className={`button primary ${styles.donateButton}`}><span>Donate&nbsp;<FontAwesomeIcon icon={faArrowRightLong} size="xs" /></span></a>
        </li>
      </ul>
      

    
    </nav>

  )
}

export default Nav